"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokenize = exports.findLongestCommonTokenSequence = void 0;

var normalizeToken = function normalizeToken(token) {
  if (!token) return '';
  var sanitizedToken = token.replace(/(^[\.\-\s]+)|([\.\-\s]+$)/g, '');
  return (sanitizedToken || token).trim().toLowerCase();
};

var defaultIsDelimiter = function defaultIsDelimiter(char) {
  return /[^\w\-\.]/.test(char);
};

var tokenize = function tokenize(str) {
  var isDelimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultIsDelimiter;
  var result = [];
  var currentTokenStartIndex = -1;

  for (var i = 0; i < str.length; i++) {
    var char = str[i];

    if (isDelimiter(char)) {
      if (currentTokenStartIndex >= 0) {
        var token = normalizeToken(str.substring(currentTokenStartIndex, i));

        if (token) {
          result.push({
            index: currentTokenStartIndex,
            endIndex: i,
            token: token
          });
        }

        currentTokenStartIndex = -1;
      }
    } else {
      if (currentTokenStartIndex < 0) currentTokenStartIndex = i;
    }
  }

  if (currentTokenStartIndex >= 0) {
    result.push({
      index: currentTokenStartIndex,
      endIndex: str.length,
      token: normalizeToken(str.substring(currentTokenStartIndex))
    });
  }

  return result;
};

exports.tokenize = tokenize;

var findLongestCommonTokenSequence = function findLongestCommonTokenSequence(tokens1, tokens2) {
  if (!tokens1.length || !tokens2.length) return [];
  var longestSequence = [];

  for (var i = 0; i < tokens1.length; i++) {
    for (var j = 0; j < tokens2.length; j++) {
      if (tokens1[i].token !== tokens2[j].token && !tokens1[i].token.endsWith(tokens2[j].token)) {
        continue;
      }

      var currentSequence = [];

      for (var k = j; k < tokens2.length; k++) {
        var token1 = tokens1[i + k - j];
        if (!token1) break;
        var token2 = tokens2[k];

        if (token1.token === token2.token) {
          currentSequence.push(token1);
        } else if (k === j && token1.token.endsWith(token2.token)) {
          currentSequence.push({
            index: token1.index + token1.token.indexOf(token2.token),
            endIndex: token1.endIndex,
            token: token2.token
          });
        } else if (k === tokens2.length - 1 && token1.token.startsWith(token2.token)) {
          currentSequence.push({
            index: token1.index,
            endIndex: token1.index + token2.token.length,
            token: token2.token
          });
        } else {
          break;
        }
      }

      if (currentSequence.length > longestSequence.length) {
        longestSequence = currentSequence;
      }

      if (longestSequence.length === tokens2.length) {
        return longestSequence;
      }
    }
  }

  return longestSequence;
};

exports.findLongestCommonTokenSequence = findLongestCommonTokenSequence;